import React from 'react';
import { Bell, AlertTriangle, CheckCircle, Clock, Users, TrendingUp } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const RenewalRequestStatisticsCard = ({ statistics }) => {
  const stats = [
    {
      label: 'Total Requests',
      value: statistics?.total || 0,
      icon: Bell,
      color: 'blue',
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-600'
    },
    {
      label: 'Pending',
      value: statistics?.pending || 0,
      icon: Clock,
      color: 'gray',
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-600'
    },
    {
      label: 'Notified',
      value: statistics?.notified || 0,
      icon: Bell,
      color: 'indigo',
      bgColor: 'bg-indigo-100',
      textColor: 'text-indigo-600'
    },
    {
      label: 'In Progress',
      value: statistics?.inProgress || 0,
      icon: TrendingUp,
      color: 'yellow',
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-600'
    },
    {
      label: 'Submitted',
      value: statistics?.submitted || 0,
      icon: CheckCircle,
      color: 'green',
      bgColor: 'bg-green-100',
      textColor: 'text-green-600'
    },
    {
      label: 'Overdue',
      value: statistics?.overdue || 0,
      icon: AlertTriangle,
      color: 'red',
      bgColor: 'bg-red-100',
      textColor: 'text-red-600'
    },
    {
      label: 'Escalated',
      value: statistics?.escalated || 0,
      icon: Users,
      color: 'orange',
      bgColor: 'bg-orange-100',
      textColor: 'text-orange-600'
    },
    {
      label: 'Critical Risk',
      value: statistics?.criticalRisk || 0,
      icon: AlertTriangle,
      color: 'red',
      bgColor: 'bg-red-100',
      textColor: 'text-red-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats?.map((stat, index) => {
        const Icon = stat?.icon;
        return (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
          >
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-600 mb-1">
                  {stat?.label}
                </p>
                <p className="text-3xl font-bold text-gray-900">
                  {stat?.value}
                </p>
              </div>
              <div className={`${stat?.bgColor} p-3 rounded-lg`}>
                <Icon className={`h-6 w-6 ${stat?.textColor}`} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RenewalRequestStatisticsCard;